






























import { Vue, Component } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";
import { OnboardingBalanceTransfer } from "@/employee/route-names";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useThemeStore } from "@/shared/store/theme";
import LinkedAccounts from "@/employee/components/shared/LinkedAccounts.vue";

@Component({
  components: {
    Button,
    GenericLoadingSpinner,
    HsaBankOnboardingFooter,
    LinkedAccounts
  }
})
export default class UpfrontContribution extends Vue {
  bankAccountStore = useBankAccountStore();
  themeStore = useThemeStore();

  mounted () {
    this.bankAccountStore.loadBankAccountState();
  }

  onSkip () {
    this.routeToBalanceTransfer();
  }

  onContinue () {
    this.routeToBalanceTransfer();
  }

  routeToBalanceTransfer () {
    this.$router.push({ name: OnboardingBalanceTransfer });
  }

  get isLoading (): boolean {
    return this.bankAccountStore.linkedAccountIsLoading;
  }

  get skipDisabled (): boolean {
    return this.bankAccountStore.hasAtLeastOneLinkedAccount
      || this.bankAccountStore.isLinkedCardIframeLoading
      || this.bankAccountStore.isAchVerifierUrlLoading;
  }

  get continueDisabled (): boolean {
    return !this.bankAccountStore.hasAtLeastOneLinkedAccount;
  }

}
